<script setup>
const projectImages = [
  {
    image: "/images/toolstation.webp",
    width: "188",
    height: "63",
  },
  {
    image: "/images/equetronic.webp",
    width: "170",
    height: "86",
  },
  {
    image: "/images/synergeyes.webp",
    width: "160",
    height: "83",
  },
  {
    image: "/images/jewesih.webp",
    width: "240",
    height: "71",
  },
  {
    image: "/images/jalapeno.webp",
    width: "190",
    height: "52",
  },
];
</script>
<template>
  <section
    class="relative bg-[linear-gradient(90deg,_#29C9FF_-32.14%,_#1E539A_9.12%,_#6F13D5_97.4%)] dark:bg-none mt-20 py-7 2xl:px-[140px] lg:px-20 px-12"
  >
    <span
      class="hidden dark:block size-[1016px] rounded-full bg-[rgba(71,17,107,0.3)] blur-[200px] absolute top-0 left-[30%]"
    />
    <p
      class="text-center text-xl text-white dark:text-[#E67AE2] mb-9 relative z-10 tracking-[0.5px]"
    >
      We’ve sharpened our skills at...
    </p>

    <div
      class="flex justify-center items-center xl:gap-[70px] max-xl:flex-wrap w-full gap-16 relative z-10"
    >
      <template v-for="project in projectImages" :key="project.image">
        <NuxtImg
          alt="Project Images"
          :src="project.image"
          :width="project.width"
          :height="project.height"
          loading="lazy"
          class="relative z-10"
          format="webp"
        />
      </template>
    </div>
  </section>
</template>

<style scoped></style>
